import { useState } from "react";

/** Defer browser autofill until the user focuses a credential field. */
export default function useInteractionAutocomplete() {
	const [activeFields, setActiveFields] = useState({});

	return (name, autoComplete) => ({
		autoComplete,
		readOnly: !activeFields[name],
		onFocus: () => setActiveFields((current) => current[name] ? current : { ...current, [name]: true }),
	});
}
